

import React from 'react'
import { Tree, TreeNode } from 'react-organizational-chart';
import { nodeDataType, treeDataType } from '../../features/roleDivision/types';
import "./GenericTree.css"


const RenderNode=(nodeData:nodeDataType)=> {
  return nodeData.map((item)=>{
    return(
      <TreeNode label={<div className='tree_node'>{item.name}</div>} >
        {item.children && 
          RenderNode(item.children)
        }
      </TreeNode>
    )

  })
}


function GenericTree(props:{treeData:treeDataType}) {
    const {treeData}=props

  return (
    <div>
         <Tree
      lineWidth={'2px'}
      lineColor={'green'}
      lineBorderRadius={'10px'}
      label={<div className='tree_root_node'>{treeData.name}</div>}
    >

    {RenderNode(treeData.children)}

    </Tree>
    </div>
  )
}

export default GenericTree